// algoliaService.js
import algoliasearch from 'algoliasearch';

// Algolia configuration
const algolia = algoliasearch(process.env.REACT_APP_ALGOLIA_APP_ID, process.env.REACT_APP_ALGOLIA_ADMIN_KEY);
const index = algolia.initIndex('rides');

// Function to index data in Algolia
export const syncAlgoliaWithFirestore = async (rides) => {
    // Convert rides data for Algolia
    const algoliaRides = rides.map(ride => {
        return { objectID: ride.id, ...ride };
    });
    console.log(algoliaRides)
    // Save to Algolia
    return index.saveObjects(algoliaRides).catch(error => {
        console.error('Error when indexing to Algolia', error);
        throw error; // rethrow the error so you can catch it when calling this function
    });
};

// Function to search in Algolia index
export const searchRides = (query) => {
    return index.search(query).then(({ hits }) => {



        return hits;
    }).catch(error => {
        console.error('Error during search: ', error);
        throw error; // rethrow the error so you can catch it when calling this function
    });
};
